import { db, functions } from '../config/firebase';
import { httpsCallable } from 'firebase/functions';
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  getDoc
} from 'firebase/firestore';


// employerId param is kept for call-site compatibility but ignored —
// the Cloud Function sets employerId from request.auth.uid.
export const createJob = async (jobData, employerId) => {
  const fn = httpsCallable(functions, 'createJob');
  const result = await fn(jobData);
  return result.data.jobId;
};

export const getEmployerJobs = async (employerId) => {
  try {
    const q = query(collection(db, 'jobs'), where('employerId', '==', employerId));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    throw error;
  }
};

export const updateJob = async (jobId, updates) => {
  const fn = httpsCallable(functions, 'updateJob');
  await fn({ jobId, updates });
};

export const getJob = async (jobId) => {
  try {
    const jobDoc = await getDoc(doc(db, 'jobs', jobId));
    if (jobDoc.exists()) {
      return { id: jobDoc.id, ...jobDoc.data() };
    }
    return null;
  } catch (error) {
    console.error('Error getting job:', error);
    throw error;
  }
};
